import Loadable from '../../components/Loadable/Loadable'
import React, { lazy } from 'react'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'

const ChirpStackPage = Loadable(lazy(() => import('./ChirpStackPage')))

const chirpStackRoutes = [
	{
		path: Page.chirpStack.path,
		element: (
			<ShowIfRole role={Page.chirpStack.auth}>
				<ChirpStackPage />
			</ShowIfRole>
		),
		auth: Page.chirpStack.auth
	}
]

export default chirpStackRoutes
